import type { Deal, Partner } from "../types";
import { useData } from "../hooks/useData";
import { api } from "../api/client";
import FormDialog from "../components/FormDialog";

/** Capture → Task: the four things you know standing in a corridor. Everything else can wait for the desktop. */
export default function QuickTask({ partners, myId, onClose, onSaved }: {
  partners: Record<string, Partner>; myId: string; onClose: () => void; onSaved: (msg: string) => void;
}) {
  const { data: deals } = useData<Deal[]>("/api/deals");
  const people = Object.values(partners).filter(p => p.active !== false);
  return (
    <FormDialog
      title="New task"
      initial={{ task: "", owner: myId, due: "", deal_id: "" }}
      fields={[
        { key: "task", label: "What needs doing", type: "textarea", required: true, wide: true, placeholder: "e.g. Send Bjørn the term sheet" },
        { key: "owner", label: "Who", type: "select", options: people.map(p => ({ value: p.id, label: p.id === myId ? `${p.name} (me)` : p.name })) },
        { key: "due", label: "Due", type: "date" },
        { key: "deal_id", label: "Deal", type: "select", options: [{ value: "", label: "— none —" }, ...(deals || []).map(d => ({ value: d.id, label: d.name }))] },
      ]}
      saveLabel="Add task"
      onClose={onClose}
      onSave={async v => {
        await api.post("/api/todos", { task: v.task.trim(), owner: v.owner || myId, due: v.due || null, deal_id: v.deal_id || null });
        onSaved(v.owner && v.owner !== myId ? `Handed to ${partners[v.owner]?.name.split(" ")[0] || v.owner}` : "Task added");
      }}
    />
  );
}
